import React, { createContext, useContext, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

const AlertContext = createContext();

export const useAlert = () => {
  const { t } = useTranslation();
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error(t("hooks.useAlert.text01"));
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");

  const showAlert = (newMessage, newSeverity = "info") => {
    setMessage(newMessage);
    setSeverity(newSeverity);
    setOpen(true);
  };

  const hideAlert = () => {
    setOpen(false);
  };

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={hideAlert}
        // message={message}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={severity}
      >
        <Alert onClose={hideAlert} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </AlertContext.Provider>
  );
};
